import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('grc_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('grc_token');
      localStorage.removeItem('grc_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  getMe: () => api.get('/auth/me'),
  forgotPassword: (data) => api.post('/auth/forgot-password', data),
  resetPassword: (data) => api.post('/auth/reset-password', data),
};

// Dashboard API
export const dashboardAPI = {
  getStats: () => api.get('/dashboard/stats'),
  getRecentActivities: () => api.get('/dashboard/recent-activities'),
};

// Frameworks API
export const frameworksAPI = {
  getAll: () => api.get('/frameworks'),
  getById: (id) => api.get(`/frameworks/${id}`),
  create: (data) => api.post('/frameworks', data),
  seedSOC2: () => api.post('/seed/soc2'),
};

// Controls API
export const controlsAPI = {
  getAll: (frameworkId) => api.get('/controls', { params: { framework_id: frameworkId } }),
  getById: (id) => api.get(`/controls/${id}`),
  create: (data) => api.post('/controls', data),
  updateStatus: (id, status) => api.put(`/controls/${id}/status?status=${status}`),
};

// Evidence API
export const evidenceAPI = {
  getAll: () => api.get('/evidence'),
  getById: (id) => api.get(`/evidence/${id}`),
  create: (data) => api.post('/evidence', data),
  updateStatus: (id, status) => api.put(`/evidence/${id}/status?status=${status}`),
  delete: (id) => api.delete(`/evidence/${id}`),
};

// Risks API
export const risksAPI = {
  getAll: () => api.get('/risks'),
  getById: (id) => api.get(`/risks/${id}`),
  create: (data) => api.post('/risks', data),
  update: (id, data) => api.put(`/risks/${id}`, data),
  delete: (id) => api.delete(`/risks/${id}`),
};

// Policies API
export const policiesAPI = {
  getAll: () => api.get('/policies'),
  getById: (id) => api.get(`/policies/${id}`),
  create: (data) => api.post('/policies', data),
  update: (id, data) => api.put(`/policies/${id}`, data),
  updateStatus: (id, status) => api.put(`/policies/${id}/status?status=${status}`),
  acknowledge: (id) => api.post(`/policies/${id}/acknowledge`),
  delete: (id) => api.delete(`/policies/${id}`),
};

export default api;
